import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
    selector: '[matBadgeIcon]'
  })
  export class MatBadgeIconDirective {
  
    @Input() matBadgeIcon: string;
    @Input() fontSizeIcon: string = '16px';
  
    constructor(private el: ElementRef) {}
  
    ngOnInit() {
      const badge = this.el.nativeElement.querySelector('.mat-badge-content');
      badge.style.display = 'flex';
      badge.style.alignItems = 'center';
      badge.style.justifyContent = 'center';
      badge.innerHTML = `<i class="material-icons" style="font-size: ${this.fontSizeIcon}">${this.matBadgeIcon}</i>`;
    }
  }